/**
 * Replaceable demo media for the civil3d / perception team.
 *
 * To swap in a real file:
 *   1. Place it at the `publicPath` below (see public/demo/README.md)
 *   2. Set `src` to that same path
 *
 * Leave `src` as null to keep the labeled placeholder.
 */
export const DEMO_ASSETS = {
  heroReconstruction: {
    id: 'hero-reconstruction',
    src: null,
    publicPath: '/demo/hero-reconstruction.mp4',
    type: 'video',
    label: '3D reconstruction hero video',
    caption: 'Reconstruction of a real environment — placeholder until demo capture lands.',
  },
  spatialMapping: {
    id: 'spatial-mapping',
    src: null,
    publicPath: '/demo/spatial-mapping.mp4',
    type: 'video',
    label: 'Live spatial mapping video',
    caption: 'On-site spatial mapping capture.',
  },
  rgbCapture: {
    id: 'rgb-capture',
    src: null,
    publicPath: '/demo/rgb-capture.png',
    type: 'image',
    label: 'RGB capture still',
    caption: 'Color capture of the reconstructed space.',
  },
  depthMap: {
    id: 'depth-map',
    src: null,
    publicPath: '/demo/depth-map.png',
    type: 'image',
    label: 'Depth map still',
    caption: 'Depth representation of the same capture.',
  },
  pointcloudMesh: {
    id: 'pointcloud-mesh',
    src: null,
    publicPath: '/demo/pointcloud-mesh.png',
    type: 'image',
    label: 'Point cloud / mesh screenshot',
    caption: 'Measurable reconstruction still.',
  },
  meshOutput: {
    id: 'mesh-output',
    src: null,
    publicPath: '/demo/mesh-output.png',
    type: 'image',
    label: 'Mesh reconstruction still',
    caption: 'Surface mesh from the reconstruction pipeline.',
  },
  perceptionHardware: {
    id: 'perception-hardware',
    src: null,
    publicPath: '/demo/perception-hardware.mp4',
    type: 'video',
    label: 'Perception hardware footage',
    caption: 'LiDAR, camera, and IMU capture hardware in the field.',
  },
  roboticsDemo: {
    id: 'robotics-demo',
    src: null,
    publicPath: '/demo/robotics-demo.mp4',
    type: 'video',
    label: 'Robotics demo',
    caption: 'Perception stack on a mobile platform.',
  },
  builtEnvironment: {
    id: 'built-environment',
    src: null,
    publicPath: '/demo/built-environment.jpg',
    type: 'image',
    label: 'Built environment capture',
    caption: 'Interior / site capture for civil3d.',
  },
  industrialVision: {
    id: 'industrial-vision',
    src: null,
    publicPath: '/demo/industrial-vision.jpg',
    type: 'image',
    label: 'Industrial environment capture',
    caption: 'Industrial plant or process capture.',
  },
  infrastructure: {
    id: 'infrastructure',
    src: null,
    publicPath: '/demo/infrastructure.jpg',
    type: 'image',
    label: 'Infrastructure capture',
    caption: 'Bridge, corridor, or outdoor works capture.',
  },
  architectureGraphic: {
    id: 'architecture-graphic',
    src: null,
    publicPath: '/demo/architecture-graphic.svg',
    type: 'image',
    label: 'Architecture graphic',
    caption: 'Perception + spatial intelligence stack.',
  },
};
